import { assignSafe } from '@summit/core';
import { of } from 'rxjs';
export class ListFooter<T> {
  groupName: string | number;
  groupId: string;
  value: string | number;
  groupDepth: number;
  baseElement: T;
  elements = new Array<T>();
  isGroupFooter: boolean;
  childGroupCount: number;

  constructor(jsonData?: Partial<ListFooter<T>>) {
    if (jsonData) {
      assignSafe(this, jsonData);
    }
  }

  get elements$() {
    return of(this.elements);
  }
}
